import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import { faPhone, faEnvelope, faMapMarkerAlt } from "@fortawesome/free-solid-svg-icons";
import { faFacebook, faInstagram, faTiktok, faXTwitter, faLinkedin } from "@fortawesome/free-brands-svg-icons";
import Logo from '../images/akt-akt (2).png';
import { Link, useLocation  } from "react-router-dom";

export default function Footer() {

  const location = useLocation();
  const isAktCarWorksPage = location.pathname === "/division/akt-car-care" ||"/division/powder-coating" || "/division/akt-car-wash";

  return (
    <>

<div className={`custom-padding ${isAktCarWorksPage ? 'bg-white border-t border-gray-200' : 'bg-[#0c2341]'}`}>

        <footer className="bg-white w-full rounded-tl-lg rounded-tr-lg">
        {/* <footer className={`custom-padding ${isAktCarWorksPage ? '' : 'bg-gray-100'}`}> */}

          {/* Main Footer Content */}
          <div className="max-w-7xl mx-auto px-4 py-8 grid grid-cols-1 md:grid-cols-3 lg:grid-cols-4 gap-8 text-gray-800">

            {/* Left Section - Logo & Contact Info */}
            <div className="space-y-4">
              <Link to="/">
                <div className="flex items-center space-x-2 mb-4">
                  <img src={Logo} alt="AKT Logo" className="h-12 md:h-16 lg:h-14" />
                </div>
              </Link>
              <h2 className="font-semibold text-xl mb-2">SAUDI ARABIA</h2>
              {/* Phone */}
              <Link to="tel:+966138471541">
                <p className="flex items-center space-x-3 text-base mt-2">
                  {/* <FontAwesomeIcon icon={faPhone} className="text-gray-700" /> */}
                  <span className="break-words">+966 13847-1541 / 847-1750</span>
                </p>
              </Link>

              {/* Address */}
              <Link to="#" onClick={() => window.open("https://www.google.com/maps?q=PO+Box+31739+Al-Khobar+31952,+Saudi+Arabia", "_blank")}>
                <p className="flex items-start space-x-4 text-base mt-2">
                  {/* <FontAwesomeIcon icon={faMapMarkerAlt} className="text-gray-700 mt-1" /> */}
                  <span className="leading-relaxed text-sm">
                    8483 Al Amir Buitan - Al Khobar Ash Shemaliyah Dist. <br />
                    Unit No 8817, Al Khobar 34426 - 3203 <br />
                    Kingdom of Saudi Arabia
                  </span>
                </p>
              </Link>

              {/* Email */}
              <Link to="mailto:info@aktcorp.com">
                <p className="flex items-center space-x-3 text-base mt-2">
                  {/* <FontAwesomeIcon icon={faEnvelope} className="text-gray-700" /> */}
                  <span>info@aktcorp.com</span>
                </p>
              </Link>
            </div>


            <div className="space-y-4">
              <div className="hidden md:block md:mt-9">
                &nbsp;
              </div>

              <h2 className="font-semibold text-xl mb-2">BAHRAIN</h2>
              {/* Phone */}
              <Link to="tel:+97377092018">
                <p className="flex items-center space-x-3 text-base mt-2">
                  {/* <FontAwesomeIcon icon={faPhone} className="text-gray-700" /> */}
                  <span className="break-words">+973 77 09 2018</span>
                </p>
              </Link>

              {/* Address */}
              <Link to="#" onClick={() => window.open("https://www.google.com/maps?q=PO+Box+31739+Al-Khobar+31952,+Saudi+Arabia", "_blank")}>
                <p className="flex items-start space-x-4 text-base mt-2">
                  {/* <FontAwesomeIcon icon={faMapMarkerAlt} className="text-gray-700 mt-1" /> */}
                  <span className="leading-relaxed text-sm">
                    ABDUL KARIM FADL TRADING WLL. CO. <br />
                    Office / Warehouse No. 44    <br />
                    Block No. 115, Road No. 1527   <br />
                    Building No. 2000, HIDD
                    Kingdom of Bahrain
                  </span>
                </p>
              </Link>
              {/* Email */}
              <Link to="mailto:info@aktcorp.com">
                <p className="flex items-center space-x-3 text-base mt-2">
                  {/* <FontAwesomeIcon icon={faEnvelope} className="text-gray-700" /> */}
                  <span>info@aktcorp.com</span>
                </p>
              </Link>


            </div>
            {/* Middle Section - Quick Links */}
            <div className="md:mt-[70px] md:ml-14">
              <h3 className="font-semibold text-xl mb-2">QUICK LINKS</h3>
              <ul className="space-y-2 text-base">
                <li><Link to="/" className="hover:text-blue-500">Home</Link></li>
                <li><Link to="/about-us" className="hover:text-blue-500">About Us</Link></li>
                <li><Link to="/media" className="hover:text-blue-500">Media</Link></li>
                <li><Link to="/compliance" className="hover:text-blue-500">Compliance</Link></li>
                <li><Link to="/contact-us" className="hover:text-blue-500">Contact Us</Link></li>
              </ul>
            </div>

            {/* Right Section - Policies & Guidelines */}
            <div className="md:mt-[70px]">
              <h3 className="font-semibold text-xl mb-2">POLICIES & GUIDELINES</h3>
              <ul className="space-y-2 text-base">
                <li><Link to="/privacy" className="hover:text-blue-500">Privacy Policy</Link></li>
                <li><Link to="/terms" className="hover:text-blue-500">Terms of Service</Link></li>
                <li><Link to="/login" className="hover:text-blue-500">Admin</Link></li>
                <li><a href="https://aktcorp.com/sitemap.xml" className="hover:text-blue-500" target="__blank">Sitemap</a></li>
                <li><Link to="/cookies" className="hover:text-blue-500">Cookie Policy</Link></li>
              </ul>
            </div>



          </div>

          {/* Bottom Section */}
          <div className="border-t border-gray-200 py-4 px-6 md:px-20 flex flex-col md:flex-row justify-between items-center text-base text-gray-900">
            <p className="mb-2 md:mb-0 text-center md:text-left text-sm md:text-base">
              Abdul Karim Fadl Trading © 1994 - 2025
            </p>

            {/* Social Media Icons */}
            <div className="flex space-x-5">
              <Link to="#" className="text-gray-800 hover:text-blue-500">
                <FontAwesomeIcon icon={faTiktok} size="lg" />
              </Link>
              <Link to="#" className="text-gray-800 hover:text-blue-500">
                <FontAwesomeIcon icon={faInstagram} size="lg" />
              </Link>
              <Link to="#" className="text-gray-800 hover:text-blue-500">
                <FontAwesomeIcon icon={faFacebook} size="lg" />
              </Link>
              <Link to="#" className="text-gray-800 hover:text-blue-500">
                <FontAwesomeIcon icon={faXTwitter} size="lg" />
              </Link>
              <Link to="#" className="text-gray-800 hover:text-blue-500">
                <FontAwesomeIcon icon={faLinkedin} size="lg" />
              </Link>
            </div>
          </div>
          <div className="py-2 md:!py-2 px-6">

          </div>
        </footer>
      </div>
    </>
  );
}
